import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'slickId'
})
export class SlickIdPipe implements PipeTransform {

    transform(value: any, ...args: any[]): any {
        if (typeof value === 'string') {
            const regexGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

            return value.replace(regexGuid, this.transformGuid);
        }

        return value;
    }

    private transformGuid(value: string): string {
        return  value.substr(0, 4) + '**' + value.substr(-4);
    }
}
